/*
 * Fades content in as it scrolls into view: a short rise and fade, once.
 *
 * Taken from kavel22, with one change: what takes part is marked in the markup
 * with `data-reveal` rather than listed here, so a new section opts in where it
 * is written.
 *
 * Only what starts below the fold is hidden, and only once this has run, so
 * nothing on screen at load blinks out and back, and without JavaScript
 * everything simply shows. With reduced motion asked for, nothing moves.
 *
 * When the fade has run the classes come off again, so the element is back
 * to its own transitions (hovers and the like).
 */

/* Elements that come into view together appear one after another. */
const STAGGER = 120;
const MAX_STAGGER = 4;

function reveal(element, delay) {
  element.style.setProperty('--reveal-delay', `${delay}ms`);
  element.classList.add('reveal--in');
  const done = (event) => {
    // A hover inside the element ends transitions too; wait for its own.
    if (event.target !== element) return;
    element.removeEventListener('transitionend', done);
    element.classList.remove('reveal', 'reveal--in');
    element.style.removeProperty('--reveal-delay');
  };
  element.addEventListener('transitionend', done);
}

function init() {
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  // In the theme editor a section is re-rendered on every change, and a band
  // that fades in after each keystroke is in the way.
  if (window.Shopify?.designMode) return;

  const targets = [...document.querySelectorAll('[data-reveal]')].filter(
    (element) => element.getBoundingClientRect().top > window.innerHeight
  );
  if (targets.length === 0) return;

  const observer = new IntersectionObserver(
    (entries) => {
      let index = 0;
      for (const entry of entries) {
        if (!entry.isIntersecting) continue;
        observer.unobserve(entry.target);
        reveal(entry.target, Math.min(index, MAX_STAGGER) * STAGGER);
        index += 1;
      }
    },
    { rootMargin: '0px 0px -8% 0px' }
  );

  for (const element of targets) {
    element.classList.add('reveal');
    observer.observe(element);
  }
}

init();
